{
  "tabs": {
    "chat": "Puisano",
    "reminders": "Likhopotso",
    "calendar": "Khalendara",
    "settings": "Lisebelisoa"
  },
  "common": {
    "cancel": "Hlakola",
    "save": "Boloka",
    "confirm": "Netefatsa",
    "delete": "Tlosa",
    "back": "Khutlela",
    "close": "Koala",
    "edit": "Hlophisa",
    "search": "Batla",
    "all": "Tsohle",
    "loading": "E jarisoa...",
    "error": "Ho na le bothata",
    "notFound": "Ha ho fumanoe",
    "tryAgain": "Ka kopo leka hape",
    "retry": "Leka hape",
    "undo": "Khutlisa",
    "pullToRefresh": "Khetha ho ntlafatsa",
    "justNow": "hona joale"
  },
  "auth": {
    "welcome": "Rea u amohela ho FishMemory",
    "tagline": "Mothusi oa hau oa likhopotso tsa WhatsApp, joale ka pokothong ea hau.",
    "subtitle": "Mothusi oa hau oa likhopotso tsa WhatsApp, joale ka pokothong ea hau.",
    "phoneLabel": "Nomoro ea hau ea WhatsApp",
    "phoneHint": "Re tla romella khoutu ea netefatso ka WhatsApp",
    "invalidPhone": "Ka kopo kenya nomoro e nepahetseng ea mohala",
    "continue": "Tsoela pele",
    "enterPhone": "Kenya nomoro ea hau ea WhatsApp",
    "phonePlaceholder": "Nomoro ea mohala",
    "sendCode": "Romella Khoutu",
    "verifyTitle": "Netefatsa nomoro ea hau",
    "otpSentTo": "Khoutu ea linomoro tse 6 e rometsoe ho {{phone}} ka WhatsApp",
    "enterFullCode": "Ka kopo kenya linomoro tsohle tse 6",
    "invalidOtp": "Khoutu e fosahetse. Ka kopo leka hape.",
    "otpFailed": "Ho hloleha ho romella khoutu. Leka hape.",
    "otpResent": "Khoutu e rometsoe hape",
    "resendIn": "Romella hape ka {{seconds}}s",
    "resendCode": "Romella khoutu hape",
    "enterOtp": "Kenya khoutu e rometsoeng ho WhatsApp ea hau",
    "verify": "Netefatsa",
    "resend": "Romella khoutu hape",
    "wrongNumber": "Nomoro e fosahetse?",
    "backToPhone": "Khutlela mohaleng",
    "editPhone": "Hlophisa nomoro ea mohala",
    "error": "Phoso",
    "setupTitle": "A re qale ka ho hlophisa",
    "setupSubtitle": "U ka fetola tsena neng kapa neng ho Lisebelisoa",
    "namePlaceholder": "Lebitso la hau",
    "letsGo": "Qeta ho hlophisa",
    "skipForNow": "Fetola hona joale"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Ngola molaetsa...",
    "inputPlaceholder": "Ngola molaetsa...",
    "typing": "FishMemory e ngola...",
    "online": "Inthaneteng",
    "connecting": "E hokahanya...",
    "reconnecting": "E hokahanya hape...",
    "offline": "E sieo marangrang",
    "empty": "Qala puisano",
    "emptyHint": "Theha likhopotso, sheba kemiso ea hau, kapa kopa thuso.",
    "emptyAction": "Romella khopotso ea mohlala",
    "actions": "Mekhoa ea puisano",
    "keep": "Boloka melaetsa",
    "clearTitle": "Hlakola puisano",
    "clearConfirm": "Na u batla ho hlakola melaetsa eohle sesebelisoa sena? Sena ha se ka sa khutlisoa.",
    "clear": "Hlakola puisano",
    "optionSelected": "E khethiloe: {{label}}",
    "sendingSelection": "E romelloa...",
    "connectionLost": "E hokahanya hape..."
  },
  "reminders": {
    "title": "Likhopotso tsa Ka",
    "active": "E sebetsa",
    "today": "Kajeno",
    "thisWeek": "Beke ena",
    "history": "Nalane",
    "items": "lintho",
    "emptyTitle": "Ha ho likhopotso hajoale",
    "emptySubtitle": "Theha e 'ngoe puisanong 'me e tla hlaha mona.",
    "emptyAction": "Bula puisano",
    "filterActive": "E sebetsa",
    "filterToday": "Kajeno",
    "filterWeek": "Beke ena",
    "filterHistory": "Nalane",
    "emptyState": "Ha ho likhopotso hajoale. Qala puisano!",
    "swipeDone": "E entsoe",
    "swipeSnooze": "E liehisa",
    "swipeDelete": "Tlosa",
    "search": "Batla likhopotso...",
    "upcoming": "E tlang",
    "completed": "E phethiloe",
    "overdue": "E fetileng nako",
    "tomorrow": "Hosane",
    "synced": "E kopantswe {{value}}",
    "swipeHint": "Swinya khopotso bakeng sa liketso tse ling",
    "noResults": "Ha ho likhopotso tse lumellanang le patlo ea hau",
    "noResultsHint": "Leka lentsoe le fapaneng kapa hlakola patlo",
    "deleteAllFailed": "Ho hloleha ho hlakola likhopotso tsohle"
  },
  "calendar": {
    "title": "Khalendara",
    "today": "Kajeno",
    "tomorrow": "Hosane",
    "completed": "e entsoe",
    "noEvents": "Ha ho liketsahalo tse behiloeng",
    "noEventsSubtitle": "Khetha letsatsi ho bona likhopotso le liketsahalo tsa khalendara.",
    "googleEvent": "Khalendara ea Google",
    "legendActive": "E sebetsa",
    "legendRecurring": "E phetoang",
    "legendDone": "E entsoe",
    "legendGoogle": "Google",
    "previousMonth": "Khoeli e fetileng",
    "nextMonth": "Khoeli e latelang",
    "previousYear": "Selemo se fetileng",
    "nextYear": "Selemo se latelang",
    "goToToday": "Eya kajeno",
    "all": "Tsohle",
    "active": "E sebetsa",
    "done": "E entsoe",
    "paused": "E emisitsoe"
  },
  "settings": {
    "title": "Lisebelisoa",
    "profile": "Boitsebiso",
    "name": "Lebitso la Pontšo",
    "enterName": "Kenya lebitso la hau",
    "language": "Puo",
    "uiLanguage": "Puo ea sesebelisoa",
    "uiLanguageHelp": "E fetola puo ea UI ea sesebelisoa, matšoao a khalendara, le tataiso ea sebopeho sesebelisoa sena feela.",
    "serverLanguage": "Puo ea puisano",
    "serverLanguageHelp": "E fetola puo e sebelisoang ke likarabo tsa seva le melaetsa ea likhopotso bakeng sa ak'haonte ea hau.",
    "timezone": "Nako ea sebaka",
    "currentTimezone": "Nako ea sebaka ea hajoale",
    "timezoneHelp": "Lihora tsohle tsa likhopotso li bontšoa ka nako ena ea sebaka.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Boloka nako ea sebaka",
    "timezoneSaved": "Nako ea sebaka e ntlafalitsoe",
    "detect": "Fumana",
    "detectFailed": "Ha ho khonehe ho fumana nako ea sebaka",
    "autoDetect": "Fumana ka GPS ka bo eona",
    "notifications": "Litsebiso",
    "notificationsHelp": "Likhopotso tse latelang li laola litsebiso tse phetoang kamora hore khopotso e fanoe. Litokelo tsa litsebiso tsa sesebelisoa li ntse li laoloa ho li-setting tsa mohala oa hau.",
    "pushEnabled": "Litsebiso tsa Push",
    "autoDoneOnFire": "E bontše e entsoe ha e qala",
    "autoDoneOnFireDesc": "Ha e bulehile, likhopotso li lula li sebetsa ho fihlela u li bontša e entsoe.",
    "googleCalendar": "Khalendara ea Google",
    "google": "Khalendara ea Google",
    "googleConnected": "E hokahantsoe",
    "googleDisconnected": "Ha e hokahane",
    "googleConnectedHelp": "Likhopotso tse ncha li ka kopanngoa khalendareng ea hau ka bo eona.",
    "googleDisconnectedHelp": "Hokela Khalendara ea Google ho boloka likhopotso le liketsahalo li lumellana.",
    "googleConnectFailed": "Ho hloleha ho hokahanya Khalendara ea Google",
    "connected": "E hokahantsoe",
    "disconnected": "Ha e hokahane",
    "connect": "Hokela",
    "disconnect": "Tlohela ho hokahanya",
    "autoSync": "Kopanya likhopotso tse ncha ka bo eona",
    "autosync": "Kopanya likhopotso tse ncha ka bo eona",
    "subscription": "Ngoliso",
    "trialUsed": "Leka: {{used}}/{{total}} e sebelisitsoe",
    "trialStatus": "Leka e fumaneha",
    "activeStatus": "Ngoliso e sebetsa",
    "expiredStatus": "Ngoliso e felile",
    "unsubscribedStatus": "Ha e ngolisoe",
    "about": "Mabapi",
    "version": "Mofuta",
    "logout": "Kena ka ntle",
    "logoutTitle": "Kena ka ntle",
    "logoutConfirm": "Na u tiile hore u batla ho kena ka ntle?",
    "noName": "Ha ho lebitso le behiloeng",
    "serverConnection": "Khokahano ea seva",
    "serverUrl": "URL ea seva",
    "serverEdit": "Hlophisa",
    "saveReconnect": "Boloka 'me u hokahanye hape",
    "resetDefault": "Khutlisa pele ho tsohle",
    "invalidServerUrlTitle": "URL ea seva e fosahetse",
    "invalidServerUrlMessage": "Kenya URL ea seva e nepahetseng ea http kapa https, mohlala https://example.com",
    "uiLanguageChangeFailed": "Ho hloleha ho fetola puo ea sesebelisoa. Ka kopo leka hape.",
    "serverLanguageChangeFailed": "Ho hloleha ho fetola puo ea puisano. Ka kopo leka hape.",
    "timezoneChangeFailed": "Ho hloleha ho fetola nako ea sebaka. Ka kopo leka hape.",
    "autoSyncChangeFailed": "Ho hloleha ho ntlafatsa kopanyo ea bo eona. Ka kopo leka hape.",
    "nameChangeFailed": "Ho hloleha ho ntlafatsa lebitso la pontšo. Ka kopo leka hape.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Lintlha tsa khopotso",
    "editTime": "Hlophisa Nako",
    "rename": "Fetola Lebitso",
    "snooze": "Liehisa",
    "snooze15": "Liehisa metsotso e 15",
    "pause": "Emisa",
    "pauseReminder": "Emisa khopotso",
    "resume": "Tsoela pele",
    "resumeReminder": "Tsoela pele ka khopotso",
    "skip": "Fetola E latelang",
    "skipOccurrence": "Fetola se etsahalang sena",
    "syncGoogle": "Kopanya ho Google",
    "delete": "Tlosa",
    "deleteTitle": "Tlosa Khopotso",
    "deleteConfirm": "Khopotso ena e tla hlakoloa ka ho sa feleng.",
    "deleteRecurringTitle": "Tlosa Khopotso e Phetoang",
    "deleteRecurringMessage": "Na u batla ho fetola se etsahalang sena kapa ho tlosa letoto lohle?",
    "deleteThisOccurrence": "Fetola Se etsahalang sena",
    "deleteEntireSeries": "Tlosa Letoto lohle",
    "done": "E entsoe",
    "markDone": "Bontša e entsoe",
    "undo": "Khutlisa",
    "undoPrompt": "Na u batla hore e be teng hape? E khutlisetse hona joale.",
    "recurring": "E phetoang",
    "nextRun": "E latelang",
    "oneTime": "Hang feela",
    "pending": "E emetse",
    "sent": "E rometsoe",
    "paused": "E emisitsoe",
    "active": "E sebetsa",
    "snoozed": "E liehisitsoe",
    "localTime": "E bontšoa ka nako ea lehae",
    "recurrence": "Phetoho",
    "created": "E entsoe",
    "tags": "Matšoao",
    "fireCount": "Linako tse qaliloeng",
    "actions": "Liketso",
    "none": "Ha ho na",
    "snoozeFailed": "Ho hloleha ho liehisa khopotso",
    "pauseFailed": "Ho hloleha ho emisa khopotso",
    "resumeFailed": "Ho hloleha ho tsoela pele ka khopotso",
    "skipFailed": "Ho hloleha ho fetola khopotso",
    "doneFailed": "Ho hloleha ho bontša khopotso e entsoe",
    "undoFailed": "Ho hloleha ho khutlisa boemo ba khopotso",
    "deleteFailed": "Ho hloleha ho tlosa khopotso",
    "rescheduleTitle": "Na u batla ho hlophisa hape?",
    "rescheduleMsg": "Khopotso ena e fetile nako. Na u batla ho e hlophisa hape?",
    "reschedule15": "Ka metsotso e 15",
    "reschedule60": "Ka hora e 1",
    "keepOverdue": "E boloke joalo"
  },
  "onboarding": {
    "slide1Title": "Rea u amohela ho FishMemory",
    "slide1Sub": "Mothusi oa hau oa likhopotso tsa botho — o tsamaisoang ke WhatsApp 'me o hahiloe bakeng sa pokotho ea hau.",
    "slide2Title": "Bua ka Tloaelo",
    "slide2Sub": "Ngola likhopotso kamoo u nahanang kateng: \"Nkhopotse ho letsetsa mme hosane ka 3pm\" — re hlokomela tse ling.",
    "slide3Title": "U se ke Ua Fosa Ntho",
    "slide3Sub": "Fumana litsebiso ka nako, hlophisa ka matšoao, 'me u lule u tseba tsohle tse bohlokoa.",
    "getStarted": "Qala",
    "next": "E latelang",
    "firstReminderTitle": "Theha khopotso ea hau ea pele!",
    "firstReminderHint": "Leka ho ngola ntho e kang:",
    "firstReminderExample": "Nkhopotse ho noa metsi hosane ka 9 AM",
    "gotIt": "Ke utloile!",
    "notifRationaleTitle": "Lule ka Nako",
    "notifRationaleBody": "FishMemory e hloka litsebiso ho u hopotsa ka nako. U tla fumana litsebiso feela bakeng sa likhopotso tseo u li thehileng.",
    "notifRationaleAllow": "Lumella Litsebiso",
    "notifRationaleLater": "Mohlomong Hamorao",
    "swipeHint": "Swinya ho le letona bakeng sa liketso tse potlakileng →",
    "calendarDragHint": "Khetha ho atolosa ↕"
  }
}
